import { useCart } from '@/hooks/useCart';
import { Link } from 'react-router-dom';

export default function CartDrawer() {
  const { items, isOpen, closeDrawer, removeFromCart, updateQuantity, total, count } = useCart();

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-[60] transition-opacity"
          onClick={closeDrawer}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-full max-w-md bg-cream-50 z-[70] shadow-2xl transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-5 border-b border-cream-300">
            <h2 className="text-lg font-bold text-charcoal-900">
              سلة التسوق ({count})
            </h2>
            <button
              onClick={closeDrawer}
              className="w-10 h-10 flex items-center justify-center text-charcoal-600 hover:text-charcoal-900"
            >
              <i className="ri-close-line text-xl" />
            </button>
          </div>

          {/* Items */}
          <div className="flex-1 overflow-y-auto p-5">
            {items.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full text-center">
                <div className="w-20 h-20 rounded-full bg-cream-200 flex items-center justify-center mb-4">
                  <i className="ri-shopping-bag-line text-3xl text-charcoal-400" />
                </div>
                <p className="text-charcoal-600 font-medium mb-1">السلة فارغة</p>
                <p className="text-sm text-charcoal-400 mb-4">استكشفي منتجاتنا وابدئي بالتسوق</p>
                <Link
                  to="/shop"
                  onClick={closeDrawer}
                  className="btn-primary"
                >
                  تسوّقي الآن
                </Link>
              </div>
            ) : (
              <div className="space-y-4">
                {items.map(item => (
                  <div
                    key={`${item.product.id}-${item.variant?.id ?? ''}`}
                    className="flex gap-4 bg-white rounded-2xl p-4 border border-cream-300"
                  >
                    <img
                      src={item.product.image}
                      alt={item.product.name}
                      className="w-20 h-24 object-cover rounded-xl flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-semibold text-charcoal-900 truncate">
                        {item.product.name}
                      </h3>
                      {item.variant && (
                        <p className="text-xs text-charcoal-400 mt-0.5">{item.variant.name}</p>
                      )}
                      <p className="text-sm font-bold text-charcoal-900 mt-1">
                        ₪{(item.variant?.price ?? item.product.price) * item.quantity}
                      </p>
                      <div className="flex items-center justify-between mt-2">
                        <div className="flex items-center gap-2 bg-cream-200 rounded-lg">
                          <button
                            onClick={() => updateQuantity(item.product.id, item.quantity - 1)}
                            className="w-8 h-8 flex items-center justify-center text-charcoal-600 hover:text-charcoal-900"
                          >
                            <i className="ri-subtract-line" />
                          </button>
                          <span className="text-sm font-medium text-charcoal-900 w-6 text-center">
                            {item.quantity}
                          </span>
                          <button
                            onClick={() => updateQuantity(item.product.id, item.quantity + 1)}
                            className="w-8 h-8 flex items-center justify-center text-charcoal-600 hover:text-charcoal-900"
                          >
                            <i className="ri-add-line" />
                          </button>
                        </div>
                        <button
                          onClick={() => removeFromCart(item.product.id)}
                          className="w-8 h-8 flex items-center justify-center text-charcoal-400 hover:text-red-500 transition-colors"
                        >
                          <i className="ri-delete-bin-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Footer */}
          {items.length > 0 && (
            <div className="border-t border-cream-300 p-5 bg-white">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm text-charcoal-600">المجموع</span>
                <span className="text-xl font-bold text-charcoal-900">₪{total}</span>
              </div>
              <Link
                to="/checkout"
                onClick={closeDrawer}
                className="btn-primary w-full text-center block"
              >
                إتمام الشراء
              </Link>
              <button
                onClick={closeDrawer}
                className="mt-3 w-full text-center text-sm text-charcoal-600 hover:text-charcoal-900 transition-colors"
              >
                مواصلة التسوق
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}